export const invalidLength = vin => vin.length < 4 || vin.length > 6
